var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}},[_c('path',{attrs:{"stroke":"#525D70","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.2","d":"M6.667 8H14m-7.333 4H14M6.667 4H14M2.667 6.667H4M2.667 4h.667v2.667M4 12H2.667c0-.667 1.333-1.333 1.333-2s-.666-1-1.333-.667"}})])
}
var staticRenderFns = []

export default { render: render }